
# try adding a tool
ResourceTool = require("./tools/ResourceTool")(window.DuocmsEditor.modules)
QuizTool = require("./tools/QuizTool")(window.DuocmsEditor.modules)
MathTool = require("./tools/MathTool")(window.DuocmsEditor.modules)
View3dTool = require("./tools/View3dTool")(window.DuocmsEditor.modules)
TrainingProgressTool = require("./tools/TrainingProgressTool")(window.DuocmsEditor.modules)
TrainingCompleteTool = require("./tools/TrainingCompleteTool")(window.DuocmsEditor.modules)
window.DuocmsEditor.start({tools:[
  TrainingProgressTool,
  TrainingCompleteTool,
  ResourceTool,
  MathTool,
  QuizTool,
  View3dTool
]})